<!-- ─────────────────────────────── TOOLBAR ─────────────────────────────── -->
<form [formGroup]="filtersForm">
  <div class="dt-toolbar">

    <!-- DATE RANGE: first on the left for dynamo -->
    <ng-container *ngIf="showDateFilter">
      <div class="dt-toolbar__item">
        <input class="form-control dt-date-input" type="date" formControlName="startDate"
          max="{{MaxInitDateValue}}" (change)="onChange($event,'startDate')" />
      </div>
      <div class="dt-toolbar__arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M5 12H19" stroke="#888" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 5L19 12L12 19" stroke="#888" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="dt-toolbar__item">
        <input class="form-control dt-date-input" type="date" formControlName="endDate"
          max="{{MaxEndDateValue}}" (change)="onChange($event,'endDate')" />
      </div>
      <button *ngIf="isOpticalShop && (typeData === 'fits' || typeData === 'gazeMaps')"
        type="button"
        class="dt-entity-search-btn"
        [class.dt-entity-search-btn--pending]="entityPending"
        [class.dt-entity-search-btn--active]="entityPending"
        (click)="applyFilters()"
        [title]="'DATATABLE.FILTERS.APPLY' | translate">
        <i class="bi bi-arrow-right"></i>
      </button>
    </ng-container>

    <!-- PER PAGE -->
    <div class="dt-toolbar__item d-flex align-items-center" id="entries">
      <span>{{ 'DATATABLE.SHOW' | translate }}</span>
      <select class="form-select dt-perpage" [(ngModel)]="pagination.perPage"
        (change)="showFilterPanel || paginationType === 'dynamo' ? onPerPageChanged() : onPageChanged()"
        [ngModelOptions]="{standalone: true}">
        <option>2</option>
        <option>5</option>
        <option>10</option>
        <option>20</option>
        <option>30</option>
      </select>
      <span>{{ 'DATATABLE.PERPAGE' | translate }}</span>
    </div>

    <!-- ENTITY SELECTOR + APPLY BUTTON -->
    <div class="dt-toolbar__item dt-entity-group" *ngIf="configSvc.currentConfigValue.childEntities && !isOpticalShop">
      <app-basic-virtual-scroll
        (callback)="callbackPartners($event)"
        [typeData]="typeData"
        (callbackClickOutside)="callbackClickOutside($event)">
      </app-basic-virtual-scroll>
      <button type="button" class="dt-entity-search-btn"
        [class.dt-entity-search-btn--pending]="entityPending"
        [class.dt-entity-search-btn--active]="entityPending"
        (click)="applyEntitySearch()"
        [title]="'DATATABLE.FILTERS.APPLY' | translate">
        <i class="bi bi-arrow-right"></i>
        <span *ngIf="hasEntityFilters" class="dt-entity-search-badge">!</span>
      </button>
    </div>

    <!-- SEARCH -->
    <div class="dt-toolbar__item dt-toolbar__search ms-auto">
      <div class="input-group" [class.search-expanded]="isTouchDevice || searchExpanded || pagination.search || pagination.search_params" id="search">
        <input *ngIf="paginationType === 'dynamo'" type="search" class="form-control"
          [placeholder]="'DATATABLE.SEARCH' | translate"
          [(ngModel)]="pagination.search_params" (ngModelChange)="onChange($event,'search')"
          (keyup.enter)="onSearchInput(applyFilters.bind(this))"
          (search)="onSearchInput(applyFilters.bind(this))"
          [ngModelOptions]="{standalone: true}">
        <input *ngIf="paginationType !== 'dynamo'" type="search" class="form-control"
          [placeholder]="'DATATABLE.SEARCH' | translate"
          [(ngModel)]="pagination.search" (ngModelChange)="onChange($event,'search')"
          (keyup.enter)="onSearchInput(showFilterPanel ? applyFilters.bind(this) : onPageChanged.bind(this))"
          (search)="onSearchInput(showFilterPanel ? applyFilters.bind(this) : onPageChanged.bind(this))"
          [ngModelOptions]="{standalone: true}">
        <span class="input-group-text border-0"
          [class.dt-search-icon--pending]="isTouchDevice && searchPending"
          [class.bg-white]="!(isTouchDevice && searchPending)"
          (click)="onSearchIconClick()"><i class="bi bi-search"></i></span>
      </div>
    </div>

    <!-- ACTIVE FILTERS CHIP -->
    <div *ngIf="hasEntityOrSearchFilters || filters_applyed" class="dt-toolbar__item">
      <button type="button" class="dt-clear-chip" (click)="cleanFilters()">
        <i class="bi bi-x-circle"></i>
        <span>{{ 'DATATABLE.FILTERS.CLEAR' | translate }}</span>
      </button>
    </div>

    <!-- MORE FILTERS BUTTON -->
    <div *ngIf="hasFiltersVisible" class="dt-toolbar__item dt-toolbar__more-filters">
      <button type="button" class="dt-filters-btn" [class.dt-filters-btn--active]="filters_applyed"
        (click)="toogleFilters()">
        <i class="bi bi-sliders2"></i>
        <span>{{ 'DATATABLE.FILTERS.MORE' | translate }}</span>
        <span *ngIf="filters_applyed && hasFiltersVisible" class="dt-filters-dot"></span>
      </button>
    </div>

  </div>
</form>

<!-- ─────────────────────────────── DRAWER BACKDROP ─────────────────────────────── -->
<div class="dt-drawer-backdrop" [class.dt-drawer-backdrop--open]="showFilters" (click)="toogleFilters()"></div>

<!-- ─────────────────────────────── DRAWER PANEL ─────────────────────────────── -->
<div class="dt-drawer" [class.dt-drawer--open]="showFilters" role="dialog" aria-modal="true">

  <div class="dt-drawer__header">
    <div class="dt-drawer__title">
      <i class="bi bi-sliders2 me-2"></i>
      <span>{{ 'DATATABLE.FILTERS.MORE' | translate }}</span>
      <span *ngIf="filters_applyed && hasFiltersVisible" class="dt-drawer__badge ms-2">!</span>
    </div>
    <button type="button" class="dt-drawer__close" (click)="toogleFilters()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="dt-drawer__body">
    <form [formGroup]="filtersForm">

      <!-- TEAM FILTER -->
      <ng-container *ngIf="showTeamFilter && (isAdmin || isDistributor)">
        <div class="dt-drawer__field">
          <label class="dt-drawer__label">{{ 'DATATABLE.FILTERS.TEAM' | translate }}</label>
          <ng-container *ngIf="isAdmin; else simpleTeamFilter">
            <ng-select
              [searchable]="true"
              [(ngModel)]="selectedTeamId"
              [ngModelOptions]="{standalone: true}"
              [disabled]="!currentDistributorId || hasMultipleDistributorsSelected"
              [loading]="isLoadingDistributorTeams"
              [placeholder]="currentDistributorId ? ('DATATABLE.FILTERS.ALLTEAMS' | translate) : (hasMultipleDistributorsSelected ? ('DATATABLE.FILTERS.CHOOSE_DISTRIBUTOR' | translate) : ('DATATABLE.FILTERS.CHOOSE_DISTRIBUTOR' | translate))"
              (ngModelChange)="onTeamChanged($event)">
              <ng-option [value]="null">{{ 'DATATABLE.FILTERS.ALLTEAMS' | translate }}</ng-option>
              <ng-option *ngFor="let team of distributorTeams" [value]="team.id">{{ team.name }}</ng-option>
            </ng-select>
          </ng-container>
          <ng-template #simpleTeamFilter>
            <ng-select [searchable]="true" [(ngModel)]="selectedTeamId" [ngModelOptions]="{standalone: true}"
              [placeholder]="'DATATABLE.FILTERS.ALLTEAMS' | translate"
              [disabled]="!!fixedTeamId"
              [items]="teamsForUser"
              bindLabel="name"
              bindValue="id"
              [clearable]="!fixedTeamId"
              (ngModelChange)="onTeamChanged($event)">
            </ng-select>
          </ng-template>
        </div>
      </ng-container>

      <!-- PACKAGE FILTERS -->
      <ng-container *ngIf="showPackageFilters">
        <div class="dt-drawer__field">
          <label class="dt-drawer__label">{{ 'DATATABLE.FILTERS.PACKAGETYPE' | translate }}</label>
          <ng-select [searchable]="false" formControlName="packageType"
            [placeholder]="'DATATABLE.FILTERS.PACKAGETYPE' | translate" (ngModelChange)="onChange($event)">
            <ng-option *ngFor="let option of package_types_filter" [value]="option.id">{{option.name}}</ng-option>
          </ng-select>
        </div>
        <div class="dt-drawer__field">
          <label class="dt-drawer__label">{{ 'DATATABLE.FILTERS.STATUS' | translate }}</label>
          <ng-select [searchable]="false" formControlName="status"
            [placeholder]="'DATATABLE.FILTERS.STATUS' | translate" (ngModelChange)="onChange($event)">
            <ng-option *ngFor="let option of status_filter" [value]="option.id">{{option.name}}</ng-option>
          </ng-select>
        </div>
        <div class="dt-drawer__field">
          <label class="dt-drawer__label">{{ 'DATATABLE.FILTERS.CATEGORY' | translate }}</label>
          <ng-select [searchable]="false" formControlName="category"
            [placeholder]="'DATATABLE.FILTERS.CATEGORY' | translate" (ngModelChange)="onChange($event)">
            <ng-option *ngFor="let option of category_filter" [value]="option.id">
              {{('LICENSE.' + (option.name | uppercase)) | translate}}
            </ng-option>
          </ng-select>
        </div>
        <div *ngIf="user.roleId === 1" class="dt-drawer__field dt-drawer__field--check">
          <label class="dt-drawer__check-label dt-baseentity-label"
            [class.dt-baseentity-label--disabled]="!currentDistributorId"
            [attr.data-tooltip]="!currentDistributorId ? ('DATATABLE.FILTERS.CHOOSE_DISTRIBUTOR' | translate) : null">
            <input class="form-check-input me-2" type="checkbox" formControlName="pendingAssignment"
              [attr.disabled]="!currentDistributorId ? true : null"
              (ngModelChange)="onChange($event)">
            {{ 'DATATABLE.FILTERS.PENDINGASSIGNMENT' | translate }}
          </label>
        </div>
        <div *ngIf="user.roleId === 2 || user.roleId === 3" class="dt-drawer__field dt-drawer__field--check">
          <label class="dt-drawer__check-label">
            <input class="form-check-input me-2" type="checkbox" formControlName="pendingAssignment" (ngModelChange)="onChange($event)">
            {{ 'DATATABLE.FILTERS.PENDINGASSIGNMENT' | translate }}
          </label>
        </div>
      </ng-container>

      <!-- DEVICE FILTERS -->
      <ng-container *ngIf="showDeviceFilters">
        <div class="dt-drawer__field">
          <label class="dt-drawer__label">Type</label>
          <ng-select [searchable]="false" formControlName="type"
            placeholder="Type" (ngModelChange)="onChange($event)">
            <ng-option value="">All</ng-option>
            <ng-option value="Scanner Head">Scanner Head</ng-option>
            <ng-option value="VR Headset">VR Headset</ng-option>
            <ng-option value="Scanner Column">Scanner Column</ng-option>
          </ng-select>
        </div>
        <div *ngIf="user.roleId === 1" class="dt-drawer__field">
          <label class="dt-drawer__label">App</label>
          <ng-select [multiple]="true" [searchable]="false" formControlName="appIds"
            placeholder="App" (ngModelChange)="onChange($event)">
            <ng-option *ngFor="let app of appsList" [value]="app.id">{{app.name}}</ng-option>
          </ng-select>
        </div>
      </ng-container>

      <!-- DYNAMO TYPE FILTER -->
      <ng-container *ngIf="paginationType === 'dynamo' && types_filter?.length">
        <div class="dt-drawer__field">
          <label class="dt-drawer__label">{{ 'DATATABLE.FILTERS.RESULTTYPE' | translate }}</label>
          <ng-select [searchable]="false" formControlName="type"
            [placeholder]="'DATATABLE.FILTERS.RESULTTYPE' | translate" (ngModelChange)="onChange($event)">
            <ng-option *ngFor="let option of types_filter" [value]="option.value">{{option.label | translate}}</ng-option>
          </ng-select>
        </div>
        <div *ngIf="user.role?.id === 1 || user.role?.id === 2" class="dt-drawer__field dt-drawer__field--check">
          <label class="dt-drawer__check-label">
            <input class="form-check-input me-2" type="checkbox" formControlName="deleted" (ngModelChange)="onChange($event)">
            {{ 'DATATABLE.FILTERS.ONLYDELETED' | translate }}
          </label>
        </div>
      </ng-container>

    </form>
  </div>

  <div class="dt-drawer__footer">
    <button type="button" class="dt-drawer__btn-clear" (click)="cleanFilters(); toogleFilters()">
      <i class="bi bi-x-circle me-1"></i>
      {{ 'DATATABLE.FILTERS.CLEAR' | translate }}
    </button>
    <button type="button" class="dt-drawer__btn-apply"
      [class.dt-drawer__btn-apply--disabled]="!apply_filters_pb && !selectedTeamId"
      (click)="applyFilters(); toogleFilters()">
      {{ 'DATATABLE.FILTERS.APPLY' | translate }}
    </button>
  </div>

</div>

<!-- ─────────────────────────────── TABLE ─────────────────────────────── -->
<div class="table-responsive">
  <table class="table table-hover">
    <thead>
      <tr>
        <th scope="col"></th>
        <th scope="col" *ngFor="let column of columns" [class]="column" (click)="onSortChanged(column)">
          <span>{{ ('DATATABLE.COLUMN.' + column.toUpperCase()) | translate }}</span>
          <hbo-field-info-icon *ngIf="column === 'created_at' || column === 'created_at_non_utc' || column === 'date'"
            [columnName]="column" (click)="$event.stopPropagation()">
          </hbo-field-info-icon>          
          <i *ngIf="paginationType !== 'dynamo' && mappLabelReverse(pagination.sort) != column" class="bi bi-caret-up"></i>
          <i *ngIf="paginationType !== 'dynamo' && mappLabelReverse(pagination.sort) == column && pagination.order === 'asc'" class="bi bi-caret-up-fill"></i>
          <i *ngIf="paginationType !== 'dynamo' && mappLabelReverse(pagination.sort) == column && pagination.order === 'desc'" class="bi bi-caret-down-fill"></i>
          <i *ngIf="paginationType === 'dynamo' && pagination.sort !== column" class="bi bi-caret-up"></i>
          <i *ngIf="paginationType === 'dynamo' && pagination.sort === column && pagination.order === 'asc'" class="bi bi-caret-up-fill"></i>
          <i *ngIf="paginationType === 'dynamo' && pagination.sort === column && pagination.order === 'desc'" class="bi bi-caret-down-fill"></i>
        </th>
      </tr>
    </thead>
    <ng-content></ng-content>
  </table>
</div>

<!-- ─────────────────────────────── SQL PAGINATION ─────────────────────────────── -->
<nav class="d-flex justify-content-between py-2" *ngIf="paginationType === 'sql' && items">
  <caption>
    <span>{{ 'DATATABLE.SHOWINGTOTAL' | translate:{ x: items.from, y: items.to, z: items.total } }}</span>
  </caption>
  <ng-container
    *ngFor="let item of items.data | paginate: { itemsPerPage: pagination.perPage, currentPage: pagination.page, totalItems: items.total }">
  </ng-container>
  <pagination-controls (pageChange)="onPageChanged($event)"
    [previousLabel]="'DATATABLE.PREVIOUS' | translate"
    [nextLabel]="'DATATABLE.NEXT' | translate">
  </pagination-controls>
</nav>

<!-- ─────────────────────────────── DYNAMO PAGINATION ─────────────────────────────── -->
<nav class="d-flex float-end py-2" *ngIf="paginationType === 'dynamo' && items">
  <ul class="pagination">
    <li class="page-item" [ngClass]="{'disabled':pagination.page == 1}">
      <a class="page-link link-dark" (click)="goDynamoPage(pagination.page!-1)">
        <i class="bi bi-chevron-left"></i> {{ 'DATATABLE.PREVIOUS' | translate }}
      </a>
    </li>
    <li *ngIf="showPrevPage()" class="page-item more-item" (click)="goDynamoPage(1)">1...</li>
    <div class="page-item-numbers">
      <div *ngFor="let page of pages">
        <li *ngIf="showPage(page.page!)" class="page-item"
          [ngClass]="{'page-item-selected':page.page! == pagination.page}"
          (click)="goDynamoPage(page.page!)">{{page.page!}}</li>
      </div>
    </div>
    <li *ngIf="checkLastPageVisible()" class="page-item more-item" (click)="goDynamoPageHide('next')">...</li>
    <li class="page-item" [ngClass]="{'disabled':!lastDynamoKey || pagination.page== -1}">
      <a class="page-link link-dark" (click)="goDynamoPage(pagination.page!+1)">
        {{ 'DATATABLE.NEXT' | translate }} <i class="bi bi-chevron-right"></i>
      </a>
    </li>
  </ul>
</nav>
